import React from 'react';
//import { useNavigate } from 'react-router-dom';
import {  useSelector } from "react-redux";
//import { portalActions } from "../../store/portal-slice";
//import { getLocalStore, setLocalStore } from "helpers/localStoreSrv";
// import whitelabelConfig from "@whitelabel-config";
//import { useUiState } from "helpers/useUiState";
import { useApi } from "helpers/useApi";
// import api from "helpers/api";
export const useAddressVerificationSrv = () => {
    //const { isAppLoading } = useUiState();
   // const dispatch = useDispatch();
    const { api } = useApi();
    const portalSessionMeta = useSelector((state: any) => state.portal.micrositeSession);
    console.log("portalSessionMeta", portalSessionMeta)
    // const postSurveySrv = (surveyid: any) => {
    //     console.log("portalSessionMeta", portalSessionMeta)
    //     // if (portalSessionMeta.urlRef) {
    //     return api.post(`MemberActivities/ByReference`, JSON.stringify(surveyid))
    //     // }
    // }

    // const patchSurveySrv = (data: any) => {
    //     if (portalSessionMeta.urlRef) {

    //         return api.patch(`MemberActivities`, data)
    //     }
    // }
    const getMemberAddresses = () => {
        console.log("portalSessionMeta ww", portalSessionMeta)
        return api.get('/api/member/addresses/')        
    }
    const submitValidateAddresses = (data:any) => {
        return api.post('/api/address/validateasync', data)
    }
    const submitMemberAddresses = (surveyData: any) => {
       // if (portalSessionMeta.urlRef) {
            //    let payload=JSON.stringify(portalSessionMeta.urlRef);
            return api.post('/api/member/address', surveyData)
       // }
    }
    // const restoreMicrositeSession = (micrositeSession: any) => {
    //     console.log(micrositeSession);
    //     dispatch(portalActions.updateMicrositeSession(micrositeSession));
    // }
    // useEffect(() => {
    //     console.log(portalSessionMeta);
    //     if (!!portalSessionMeta.urlRef) setLocalStore('MS', portalSessionMeta)
    // }, [portalSessionMeta])
    // useEffect(() => {
    //     const prevMS = getLocalStore('MS');
    //     if (prevMS) restoreMicrositeSession(prevMS)
    // }, [])
    return {  getMemberAddresses, submitMemberAddresses, submitValidateAddresses }
}